export function sortByTitle(data, mode = "none") {
    if (!Array.isArray(data)) {
        console.warn("sortByTitle: データが配列ではありません");
        return [];
    }

    if (mode === "none") {
        return [...data];
    }

    const sortedData = [...data].sort((a, b) => {
        const titleA = a.media?.name || "";
        const titleB = b.media?.name || "";

        if (mode === "asc") {
            return titleA.localeCompare(titleB, "ja");
        } else if (mode === "desc") {
            return titleB.localeCompare(titleA, "ja");
        }

        return 0;
    });

    return sortedData;
}

export function sortByFileName(data, mode = "none") {
    if (!Array.isArray(data)) {
        console.warn("sortByFileName: データが配列ではありません");
        return [];
    }

    if (mode === "none") {
        return [...data];
    }

    const sortedData = [...data].sort((a, b) => {
        const fileNameA = a.media?.filename || a.media?.name || "";
        const fileNameB = b.media?.filename || b.media?.name || "";

        if (mode === "asc") {
            return fileNameA.localeCompare(fileNameB, "ja");
        } else if (mode === "desc") {
            return fileNameB.localeCompare(fileNameA, "ja");
        }

        return 0;
    });

    return sortedData;
}

export function sortByDate(data, mode = "none") {
    if (!Array.isArray(data)) {
        console.warn("sortByDate: データが配列ではありません");
        return [];
    }

    if (mode === "none") {
        return [...data];
    }

    const sortedData = [...data].sort((a, b) => {
        const dateA = new Date(a.media?.uploaded_at || a.media?.created_at || 0);
        const dateB = new Date(b.media?.uploaded_at || b.media?.created_at || 0);

        if (mode === "asc") {
            return dateA - dateB;
        } else if (mode === "desc") {
            return dateB - dateA;
        }

        return 0;
    });

    return sortedData;
}

export function sortByType(data, mode = "none") {
    if (!Array.isArray(data)) {
        console.warn("sortByType: データが配列ではありません");
        return [];
    }

    if (mode === "none") {
        return [...data];
    }

    const typeOrder = { image: 1, video: 2, audio: 3 };

    const sortedData = [...data].sort((a, b) => {
        const typeA = a.media?.media_type || "";
        const typeB = b.media?.media_type || "";

        const orderA = typeOrder[typeA] || 999;
        const orderB = typeOrder[typeB] || 999;

        if (mode === "asc") {
            return orderA - orderB;
        } else if (mode === "desc") {
            return orderB - orderA;
        }

        return 0;
    });

    return sortedData;
}
